<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  name: 'App',
  data() {
    return {
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="less">
#app {
}
</style>
